import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../../components/modal";
import DeleteConfirmation from "../../../../components/delete-confirmation";
import { useDeleteMetaData } from "./hooks";
import { useUser } from "../../../../common-hooks/user";

const DeleteMetaData = ({ metaData }) => {
  const {
    deleteMetaDataLoading,
    handleDeleteMetaData,
    isOpenModal,
    toggleModal,
  } = useDeleteMetaData(metaData);

  const { isAdmin, isModerator } = useUser();

  if (!isAdmin && !isModerator) {
    return null;
  }

  return (
    <>
      <Tooltip title="Delete" placement="bottom">
        <i
          className={`fa fa-trash icon-btn-action text-danger `}
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <DeleteConfirmation
              message="Are you sure you want to delete?"
              handleDelete={handleDeleteMetaData}
              isLoading={deleteMetaDataLoading}
            />
          }
          title="Delete Meta Data"
        />
      ) : null}
    </>
  );
};

export default DeleteMetaData;
